import { appClient } from './api-client';

export default appClient;
